import { z } from 'zod'
import { Currency } from '../../enums/currency.enum'

// merged "link + import" broker flow: links the broker account (which establishes the dividend
// tracking baseline), persists the payout categories/templates, and imports the explicitly-selected
// historical payouts in a single atomic request. operationIds MAY be empty (link without importing).
export const linkAndImportRequestSchema = z.object({
  displayCurrency: z.nativeEnum(Currency),
  dividendCategoryId: z.string().nullable().optional(),
  couponCategoryId: z.string().nullable().optional(),
  dividendDescriptionTemplate: z.string().nullable().optional(),
  couponDescriptionTemplate: z.string().nullable().optional(),
  operationIds: z.array(z.string()),
})

export type LinkAndImportRequestDto = z.infer<typeof linkAndImportRequestSchema>
